import React, { useCallback, useEffect, useState } from "react";
import { Collapse } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { LANGS } from "../../constants/language";
import { MChevronRight } from "../commons/MIcon";

const LangCollapse = () => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [lang, setLang] = useState(LANGS.find(x => x.value === i18n?.language) || LANGS[0]);

  useEffect(() => {
    i18n?.language && setLang(LANGS.find(x => x.value === i18n.language || i18n.language.includes(x.value)));
  }, [i18n?.language])

  const changeLanguage = useCallback((langCode) => {
    i18n.changeLanguage(langCode);
  }, [i18n]);

  return <>
    <div 
      className={`bg-white rounded border ${open ? "border-primary-300" : "border-content_body"} `}
      style={{
        transition: "all 0.2s",
      }}
    >
      <div
        className="d-flex align-items-center justify-content-between p-3 cursor-pointer user-select-none"
        onClick={() => setOpen(prev => !prev)}
      >
        <div>
          {t("Language")}
        </div>
        <div className="d-inline-flex align-items-center gap-2">
          <div className="text-primary fw-bolder">
            {lang?.label || i18n?.language?.toLocaleUpperCase() || "English"}
          </div>
          <MChevronRight
            className={open ? "text-primary-500" : "text-gray-700"}
            style={{
              transition: "all 0.2s",
              transform: `rotate(${open ? 0 : -90}deg)`,
            }}
          />
        </div>
      </div>
      <Collapse in={open}>
        <div>
          {LANGS.map(l => <React.Fragment key={l.value}>
            <div
              className={`border-top border-divider p-3 ${l.value === lang?.value ? "text-primary fw-bolder" : "cursor-pointer"}`}
              onClick={() => changeLanguage(l.value)}
            >
              {l.label}
            </div>
          </React.Fragment>)}
        </div>
      </Collapse>
    </div>
  </>
};

export default LangCollapse;